<template>
  <div class="tw-py-3 tw-px-3 tw-border tw-rounded-md">
    <credit-card-read :user-id="userId" :business-id="businessId" :user-business-plan-id="userBusinessPlanId" :is-updating.sync="isUpdating" ref="read" />
    <credit-card-update :user-id="userId" :business-id="businessId" :user-business-plan-id="userBusinessPlanId" v-if="isUpdating" @updated="handleUpdate" />
  </div>
</template>

<script>
export default {
  components: {
    CreditCardRead: () => import("@/components/CreditCardv2/CreditCardRead.vue"),
    CreditCardUpdate: () => import("@/components/CreditCardv2/CreditCardUpdate.vue"),
  },
  props: {
    userId: String,
    businessId: String,
    userBusinessPlanId: String,
  },
  data() {
    return {
      isUpdating: false,
    };
  },
  methods: {
    handleUpdate() {
      this.$refs.read.getCard();
      this.isUpdating = false;
    },
  },
};
</script>

<style></style>
